import { Component, OnInit, Renderer2, Inject, ChangeDetectorRef, NgZone } from '@angular/core'; 
import { ActivatedRoute, Router } from "@angular/router" 
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '@services/security';
import _ from 'lodash'; 
import { ConfirmEmailRequestModel } from '@shared/security/confirm-email-request.model';


@Component({
  standalone: false,
  selector: 'app-confirm-account',
  templateUrl: './confirm-account.component.html',
  styleUrls: ['./confirm-account.component.scss'] 
})
export class ConfirmAccountComponent implements OnInit  {  
    infoMessage:string;  
    userId:string;
    token:string;
    step:number = 1;
    page:string;
    isError:boolean=false;
    submitted:boolean=false; 
    isConfirmed:boolean=false;
    CryptedEmail:string;

    constructor(private authService: AuthenticationService,
        private router: Router,
        private route:ActivatedRoute, 
        private changeDedectionRef :ChangeDetectorRef,
        @Inject(DOCUMENT) private _document,   private zone: NgZone) {
        }

        
  ngOnInit() {   
    this.confirmAccout();
  }

  ngAfterContentChecked(): void {
    this.changeDedectionRef.detectChanges();
  }  

  confirmAccout(){ 
    this.token = this.route.snapshot.queryParams["token"];
    this.userId = this.route.snapshot.queryParams["userid"];
    if(_.isEmpty(this.token) || _.isEmpty(this.userId))
    this.redirectToLogin();
    const request = new ConfirmEmailRequestModel();
    request.Token = this.token;
    request.UserId = this.userId;
    this.submitted = true;
    this.authService.ConfirmEmail(request).subscribe((response:any)=>{ 
         if(response != null && response !== undefined && response.IsConfirmed)
         {
            this.isConfirmed = response.IsConfirmed;
            this.CryptedEmail = response.CryptedEmail;
         }          
         else
           this.isError = true;
        });
  }
 
 redirectToLogin(){
  this.router.navigate(['/login']);
 }

 redirectToCreatePassword(url : string){
  this.zone.runOutsideAngular(() => {
    window.location.href = url;
  });
 }
}
